/*
 * @Descripttion:
 * @Author: 李子和
 * @Date: 2020-04-15 16:49:20
 */
export default [
  {
    path: '/temples',
    name: '寺庙列表管理',
    hidden: false,
    meta: {
      title: '寺庙列表管理',
      icon: '',
      nav: 'act',
      level: 1
    },
    component: resolve => require(['@/views/Application.vue'], resolve),
    children: [
      {
        path: '/temples',
        name: 'temples',
        hidden: false,
        meta: {
          title: '寺庙列表管理',
          level: 1,
          nav: 'act',
          icon: ''
        },
        component: resolve => require(['@/views/temples'], resolve)
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/router-compmange.js